var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_6291_18592)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6291_18592",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6291_18592",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6291_18592",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACsElEQVR4nO3dvW7UQBQF4HMRAiQoCKKEBgnxCGkA8bNo29BABW8Q8TwInoAiQiDxIxSJJRWPgKBDUCZFKJbqUKwLijjJbu74zOyer7St6xmfHXvslWzAzMzMzMzMzMxWRZQsTvIBgEcAbgG4AuB8yf0d4T2AhxHxV9iGYZC8QXLC+rwjeVZ9fIoieZvkrvhAH6aqEFJPQSSvAfgK4HJm3QI+AtiIiKm6IaeS671E/QcfAMYAXpM8p25IWgAkRwDuZtUbwBjAVk2noxMh+aLnnDsluUny4sDtafKasDCS33o6uClqzzzaD4Hkfk/nBv3l/9eeebUdQl+vamvPET5w4Atz9iyoBW8PWVfN7GhuDY2AMyTf1DYSTqyVALp1yxdCSwF065crhNYC6LZZnhBaDKDbbjlCaDWAbtv2Q2g5gG57SQhpj6P7OhcRRf9161Mw/NRH2at4I3ZSYwBbWcU8AhaU1S+PADEHIOYAxE6rG1BK1jm69LXEI0DMAYg5ADEHIOYAxByAmAMQcwBiDkDMAYg5ALHqngW18hw/i0eAmAMQcwBiDkDMAYhVNwuqbZZSmkeAmAMQcwBiDkDMAYhVNwvKehbUymzKI0DMAYg5ADEHIOYAxKqbBbUye8niESDmAMQcgJgDEHMAYg5AzAGIOQCxzAD2D1pI0WsrM5C81LPqwL4uIjOA3z3LnybuY2hPepb/GrQVx8HDX138jOSauo3HRXKta/O0p0/Ps/aV+baUEYBPWfUqN4qI7YxC2d8P2AZwL7NmhSYRcSerWHYA1zH7gEMzp5s57QJYj4gfWQVTp6ER8R3ABoC9zLqV2MXsVWVpBx8ocB8QEV8ArAOYZNcW+ozZL38nu3Dpz1jdB/AYwE0AVwFcKLm/RH8A/ASwA+BV1gXXzMzMzMzMzMxW2z8bV573uKg7gAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.c18637f36e601263770747e2250797f4.svg";
export { ForwardRef as ReactComponent };